import { HostType, IPrivateAPI } from './types';
import { PlatformPrivateServices } from './PlatformPrivateServices';

import {
  AccessibilityNamespace,
  ApplicationManagerNamespace,
  AuthNamespace,
  BindingsNamespace,
  BlocksMigrationNamespace,
  BreakpointsNamespace,
  BuilderComponentNamespace,
  CMSBindingsNamespace,
  ComponentsNamespace,
  ContextActionsNamespace,
  ControllersNamespace,
  CustomElementNamespace,
  DesignPresetsNamespace,
  ExperimentsNamespace,
  ExternalPanelsNamespace,
  InfoNamespace,
  InputsNamespace,
  PagesNamespace,
  PanelsNamespace,
  ProvidersNamespace,
  RefComponentsNamespace,
  RoutersNamespace,
  UserPreferencesNamespace,
  WorkspaceNamespace,
} from './namespaces';

export const COMMON_NAMESPACES = [
  AccessibilityNamespace,
  RefComponentsNamespace,
  InfoNamespace,
  ComponentsNamespace,
  ApplicationManagerNamespace,
  CustomElementNamespace,
  InputsNamespace,
  ExperimentsNamespace,
  AuthNamespace,
  PanelsNamespace,
  UserPreferencesNamespace,
  DesignPresetsNamespace,
  BuilderComponentNamespace,
  BlocksMigrationNamespace,
  ControllersNamespace,
  CMSBindingsNamespace,
  WorkspaceNamespace,
  PagesNamespace,
  RoutersNamespace,
];

export const CLASSIC_NAMESPACES = [] as const;

export const EDITORX_NAMESPACES = [BreakpointsNamespace] as const;

export const STUDIO_NAMESPACES = [
  ...EDITORX_NAMESPACES,
  ExternalPanelsNamespace,
  ProvidersNamespace,
  BindingsNamespace,
  ContextActionsNamespace,
];

function getPrivateApiNamespaces<T extends HostType>(hostType: T) {
  switch (hostType) {
    case HostType.Classic:
      return [...COMMON_NAMESPACES, ...CLASSIC_NAMESPACES];

    case HostType.Editorx:
      return [...COMMON_NAMESPACES, ...EDITORX_NAMESPACES];

    case HostType.MobileStudio:
    case HostType.Studio:
    case HostType.Studio2:
    case HostType.Editor3:
    case HostType.Blocks:
      return [...COMMON_NAMESPACES, ...STUDIO_NAMESPACES];

    default:
      throw new Error(`Unsupported host type: "${hostType}"`);
  }
}

type NamespaceFactory = ReturnType<typeof getPrivateApiNamespaces>[number];

export function createPrivateAPI(
  hostType: HostType,
  ps: PlatformPrivateServices,
): IPrivateAPI {
  const namespaces = getPrivateApiNamespaces(hostType);

  return (namespaces as NamespaceFactory[]).reduce((api, factory) => {
    return {
      ...api,
      [factory.namespace]: new factory(hostType, ps),
    };
  }, {} as IPrivateAPI);
}
